(() => {
  const setup = () => {
    const slideshow = document.querySelector('.template-index [data-slideshow]');
    if (!slideshow || slideshow.dataset.heightReady) return;
    slideshow.dataset.heightReady = 'true';
    const hero = slideshow.querySelector('.hero.cz-slide');
    const content = hero?.firstElementChild;
    if (!content) return;
    let frame;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (hero.hidden) return;
        const style = getComputedStyle(hero);
        const intrinsic = Math.ceil(content.getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
        let height = intrinsic;
        if (innerWidth > 1000) {
          const brands = document.querySelector('.cz-brands-compact');
          const trust = document.querySelector('.cz-engagements');
          const reserve = (brands?.getBoundingClientRect().height || 0) + (trust?.getBoundingClientRect().height || 0) + parseFloat(getComputedStyle(slideshow).paddingBottom);
          height = Math.max(intrinsic, innerHeight - (slideshow.getBoundingClientRect().top + scrollY) - reserve);
        }
        const value = `${Math.ceil(height)}px`;
        if (slideshow.style.getPropertyValue('--cz-slide-height') !== value) slideshow.style.setProperty('--cz-slide-height', value);
      });
    };
    const observer = new ResizeObserver(measure);
    [content,document.querySelector('header'),document.querySelector('.cz-brands-compact'),document.querySelector('.cz-engagements')].filter(Boolean).forEach(node => observer.observe(node));
    new MutationObserver(measure).observe(hero,{attributes:true,attributeFilter:['hidden']});
    addEventListener('resize',measure);
    document.fonts?.ready.then(measure);
    measure();
    document.addEventListener('shopify:section:unload',event => {if(event.target.contains(slideshow)){observer.disconnect();cancelAnimationFrame(frame);removeEventListener('resize',measure);}});
  };
  document.addEventListener('DOMContentLoaded',setup);
  document.addEventListener('shopify:section:load',setup);
})();
